export default __webpack_public_path__ + "static/media/upload_file_filled.37dc7e53.svg";